import {createRouter, createWebHashHistory} from 'vue-router';
//import SDKService from './service/SDKService'
//meta.needLogin: default need, false: did not login.
const routes = [
    {
        path: '/getaquote',
        name: 'getaquote',
        component: () => import('./pages/GetQuote.vue'),
        meta: {
            needLogin: false
        }
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

//在router前检查是否已经登录过。
router.beforeEach(function (to, from, next) {    
    //if (to.path != "/login" && to.path != "/selectProject" && to.path != "/TrackAndTrace" && to.path != "/getaquote"){
    //    localStorage.setItem("preRoute", to.path);
    //}
    //else if(to.path=="/login"){
    //    console.log("Welcome to MyDimerco");
    //}
    //if (to.meta.needLogin == null || to.meta.needLogin == true) {
    //    var sdkService = new SDKService();
    //    try {
    //        const CorrectAccessToken = localStorage.getItem('CorrectAccessToken');
    //        sdkService.getCurrentUser(null, CorrectAccessToken).then((data) => {
    //            if (data != null && data.hqid > 0) {
    //                next();
    //            } else {
    //                next({ name: "login" });
    //            }
    //        }).catch(function (error) {
    //            console.log(error);
    //            next({ name: "login" });
    //        });
    //    }
    //    catch {
    //        next({name: "login"});
    //    }
    //}else{

    //}
    next();
});

export default router;